import { useTheme } from '@mui/material'
import type { FC } from 'react'
import { BARCODE_PREVIEW_BAR_HEIGHT, type BarcodePreviewBar } from './model'

type Props = {
  bars: BarcodePreviewBar[]
  svgWidth: number
}

// SVGでバーコードのプレビューを描画するコンポーネント
export const BarcodePreviewGraphic: FC<Props> = ({ bars, svgWidth }) => {
  const { palette } = useTheme()

  return (
    <svg
      width="100%"
      height={BARCODE_PREVIEW_BAR_HEIGHT}
      viewBox={`0 0 ${svgWidth} ${BARCODE_PREVIEW_BAR_HEIGHT}`}
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      {bars.map(bar => (
        <rect
          key={bar.x}
          x={bar.x}
          y={0}
          width={bar.width}
          height={BARCODE_PREVIEW_BAR_HEIGHT}
          fill={bar.inRange ? palette.primary.main : palette.grey[400]}
        />
      ))}
    </svg>
  )
}
